import {
    BadgeCheck,
    MailIcon,
    SquareMenu,
    UserIcon,
    UsersIcon,
    UsersRound
} from "lucide-react-native";

export const menuItems = [
    {
        id: 1,
        titleKey: "about-us",
        icon: BadgeCheck,
        routeName: "AboutUs"
    },
    {
        id: 2,
        titleKey: "president",
        icon: UserIcon,
        routeName: "AboutPresident"
    },
    {
        id: 3,
        titleKey: "board-of-directors",
        icon: UsersIcon,
        routeName: "BoardDirectors"
    },
    {
        id: 4,
        titleKey: "old-presidents",
        icon: UsersRound,
        routeName: "OldPresidents"
    },
    {
        id: 5,
        titleKey: "contact_form",
        icon: MailIcon,
        routeName: "ContactFormForMembers"
    },
    {
        id: 6,
        titleKey: "privacy-policy",
        icon: SquareMenu,
        routeName: "PrivacyPolicy"
    },
    {
        id: 7,
        titleKey: "member-policy",
        icon: SquareMenu,
        routeName: "MemberPolicy"
    },
    {
        id: 8,
        titleKey: "kvkk",
        icon: SquareMenu,
        routeName: "KVKK"
    }
] as const;
